import Start from "../pages/start/Start";
import CityPage from "../pages/city-page/CityPage";
import CommunityPage from "../pages/communities/community-page/CommunityPage";
import GalleryOfProperty from "../pages/gallery-of-property/GalleryOfProperty";
import PropertyFloorPlans from "../pages/property-floor-plans/PropertyFloorPlans";
import PropertyVideos from "../pages/videos-of-property/PropertyVideos";
import Error from "../pages/error-page/Error";
import Admin from "../pages/admin/Admin";

export const routesConfig = [
    {
        path: "/",
        element: <Start />,
    },
    {
        path: "/admin/*",
        element: <Admin />,
    },
    {
        path: "/:cityName",
        element: <CityPage />,
    },
    {
        path: "/:cityName/:communityName",
        element: <CommunityPage />,
    },
    {
        path: "/:cityName/:communityName/:propertyName",
        element: <CommunityPage />,
    },
    {
        path: "/:cityName/:communityName/:propertyName/gallery",
        element: <GalleryOfProperty />,
    },
    {
        path: "/:cityName/:communityName/:propertyName/videos",
        element: <PropertyVideos />,
    },
    {
        path: "/:cityName/:communityName/:propertyName/floor-plans",
        element: <PropertyFloorPlans />,
    },
    {
        path: "/:cityName/:communityName/:propertyName/documents",
        element: <PropertyFloorPlans />,
    },
    {
        path: "/:cityName/:communityName/:propertyName/others",
        element: <PropertyFloorPlans />,
    },
    {
        path: "*",
        element: <Error />,
    },
];
